import AppDispatcher from '../dispatcher/AppDispatcher';
import { ActionTypes, RAILCARD1617_CODE } from '../constants/AppConstants';
import Railcard1617Service from '../services/Railcard1617Service';
import AccountRailcard from '../records/AccountRailcard';

const Railcard1617Actions = {
    addGuestRailcard(guestRailcardForm) {
        const railcard = new AccountRailcard({
            firstName: guestRailcardForm.get('firstName'),
            isGuest: true,
            lastName: guestRailcardForm.get('lastName'),
            railcardCode: RAILCARD1617_CODE,
            railcardNumber: guestRailcardForm.get('railcardNumber')
        });

        AppDispatcher.dispatch({
            railcard,
            actionType: ActionTypes.RAILCARD1617_LOADED
        });
    },

    async load(user) {
        if (user && user.id) {
            AppDispatcher.dispatch({ actionType: ActionTypes.RAILCARD1617_LOAD_STARTED });
            try {
                const railcards = await Railcard1617Service.getRailcards(user);
                AppDispatcher.dispatch({
                    railcards,
                    actionType: ActionTypes.RAILCARD1617_LOADED
                });
                return railcards;
            } catch (error) {
                AppDispatcher.dispatch({ actionType: ActionTypes.RAILCARD1617_LOAD_FAILED });
                throw error;
            }
        }

        return null;
    },

    flashCheckbox(flashCheckbox) {
        AppDispatcher.dispatch({ actionType: ActionTypes.RAILCARD1617_FLASH_CHECKBOX, flashCheckbox });
    },

    remove() {
        AppDispatcher.dispatch({ actionType: ActionTypes.RAILCARD1617_REMOVE });
    },

    resetValidation() {
        AppDispatcher.dispatch({ actionType: ActionTypes.RAILCARD1617_RESET_VALIDATION });
    },

    async linkToAccount({ firstName, lastName, railcardNumber, sync, expiryDate, user }) {
        if (user && user.id) {
            try {
                return await Railcard1617Service.linkToAccount({
                    firstName,
                    lastName,
                    railcardNumber,
                    syncWithKeygo: sync,
                    user,
                    expiryDate: expiryDate.format('YYYY-MM-DD')
                });
            } catch (error) {
                AppDispatcher.dispatch({ actionType: ActionTypes.RAILCARD1617_VALIDATION_FAILED, message: error.message });
            }
        }

        return null;
    },

    async syncWithKeyGo({ railcardId, userId }) {
        if (userId) {
            const response = await Railcard1617Service.syncWithKeyGo({ railcardId, userId });
            return response !== null;
        }

        return false;
    },

    setChecked(checked) {
        AppDispatcher.dispatch({ actionType: ActionTypes.RAILCARD1617_CHECKED, checked });
    },

    async validate({ railcardNumber, firstName, lastName, expiryDate }) {
        AppDispatcher.dispatch({ actionType: ActionTypes.RAILCARD1617_VALIDATION_STARTED });
        try {
            const response = await Railcard1617Service.validate({ railcardNumber, firstName, lastName, expiryDate });
            if (response.isValid) {
                AppDispatcher.dispatch({
                    railcardNumber,
                    firstName,
                    lastName,
                    expiryDate: response.get('expiryDate'),
                    actionType: ActionTypes.RAILCARD1617_VALIDATION_COMPLETED
                });
                return true;
            } else {
                AppDispatcher.dispatch({ actionType: ActionTypes.RAILCARD1617_VALIDATION_FAILED, message: 'booking.railcard1617.errors.invalid' });
            }
        } catch (error) {
            AppDispatcher.dispatch({ actionType: ActionTypes.RAILCARD1617_VALIDATION_FAILED });
        }
        return false;
    }
};

export default Railcard1617Actions;
